import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

type ApplicationType = 'cultivation' | 'goat' | 'dairyCattle';

interface ApplicationInformation {
  applicationKey: string;
  organisationId: string;
}

@Injectable({
  providedIn: 'root',
})
export class AgroVisionUrlService {
  private readonly env = inject<Environment>(EnvironmentInjector);
  private applicationKeys: { [key in ApplicationType]: ApplicationInformation } = {
    cultivation: {
      applicationKey: 'AgrifirmFocusCultivation',
      organisationId: '43908',
    },
    goat: {
      applicationKey: 'AgrifirmFocusGoat',
      organisationId: '46370',
    },
    dairyCattle: {
      applicationKey: 'AgrifirmFocusDairyCattleWeb',
      organisationId: '15944',
    },
  };

  private baseUrl = `${this.env.API_BASE_URL}/service/navigation-v2/secure/navigation/`;

  constructor(private readonly http: HttpClient) {}

  public getAgroVisionUrl = (
    applicationType: ApplicationType,
    customerId: number,
  ): Observable<URL | null> => {
    const requestUrl = this.constructNavigationServiceAgroVisionUrl(
      this.applicationKeys[applicationType],
      customerId,
    );

    return this.http
      .get(requestUrl.toString(), { responseType: 'text' })
      .pipe(map((responseUrl) => new URL(responseUrl)));
  };

  private constructNavigationServiceAgroVisionUrl = (
    { organisationId, applicationKey }: ApplicationInformation,
    customerId: number,
  ): URL =>
    new URL(
      `agrovision?orgId=${organisationId}&applicationKey=${applicationKey}&customerId=${customerId}`,
      this.baseUrl,
    );
}
